import { NoteFolderSystemKey } from 'enums';

/**
 * The English name the server stores when a client creates a system folder. Any other
 * name is the user's rename, which is shown as is (issue #3889).
 */
export const NOTE_FOLDER_SYSTEM_DEFAULT_NAMES: Record<
  NoteFolderSystemKey,
  string
> = {
  [NoteFolderSystemKey.MEETING_RECORDINGS]: 'Meeting Recordings'
};

export const NOTE_FOLDER_SYSTEM_LABEL_KEYS: Record<
  NoteFolderSystemKey,
  string
> = {
  [NoteFolderSystemKey.MEETING_RECORDINGS]:
    'notes_page.folders.meeting_recordings'
};
